/**
 * exp/download — form popup modal (shared contact-modal behaviour) + HubSpot embed.
 */
function strlInitDownloadHubspotForms() {
	if ( window.__strlDownloadHubspotReady__ ) {
		return;
	}

	const container = document.querySelector( '.dynamic-hubspot-container[data-hubspot-scripts]' );
	if ( ! container ) {
		return;
	}

	window.__strlDownloadHubspotReady__ = true;

	const scriptsData = JSON.parse( container.dataset.hubspotScripts );

	function getSelectedCountry() {
		const params = new URLSearchParams( window.location.search );
		let country = params.get( 'country' );

		if ( country ) {
			return country.toLowerCase();
		}

		const cookieMatch = document.cookie.match( /(?:^|;\s*)era_country_pref=([^;]*)/ );

		if ( cookieMatch ) {
			return decodeURIComponent( cookieMatch[ 1 ] ).toLowerCase();
		}

		return 'global';
	}

	const selectedCountry = getSelectedCountry();
	const data = scriptsData[ selectedCountry ] || scriptsData.global;

	if ( ! data || ! data.portal_id || ! data.form_id ) {
		return;
	}

	function loadHubspotScript( callback ) {
		if ( window.hbspt && window.hbspt.forms ) {
			callback();
			return;
		}

		const script = document.createElement( 'script' );
		script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
		script.charset = 'utf-8';
		script.onload = callback;
		document.head.appendChild( script );
	}

	loadHubspotScript( function () {
		const formContainer = document.createElement( 'div' );
		formContainer.id = 'hubspot-form-' + selectedCountry;
		container.appendChild( formContainer );

		window.hbspt.forms.create( {
			portalId: data.portal_id,
			formId: data.form_id,
			region: 'eu1',
			target: '#' + formContainer.id,
		} );
	} );
}

function strlInitDownloadModals() {
	if ( ! window.__strlContactsModalsReady__ ) {
		window.__strlContactsModalsReady__ = true;

		let activeModal = null;

		const openModal = ( modalId ) => {
			if ( ! modalId ) {
				return;
			}

			const modal = document.getElementById( modalId );
			if ( ! modal || ! modal.matches( '[data-contact-modal]' ) ) {
				return;
			}

			modal.removeAttribute( 'hidden' );
			modal.setAttribute( 'aria-hidden', 'false' );
			document.documentElement.classList.add( 'overflow-hidden' );
			document.body.classList.add( 'overflow-hidden' );
			activeModal = modal;
		};

		const closeModal = ( modal ) => {
			if ( ! modal ) {
				return;
			}

			modal.setAttribute( 'aria-hidden', 'true' );
			modal.setAttribute( 'hidden', '' );
			document.documentElement.classList.remove( 'overflow-hidden' );
			document.body.classList.remove( 'overflow-hidden' );
			if ( activeModal === modal ) {
				activeModal = null;
			}
		};

		document.addEventListener( 'click', ( event ) => {
			const trigger = event.target.closest( '[data-contact-modal-target]' );
			if ( trigger ) {
				event.preventDefault();
				openModal( trigger.getAttribute( 'data-contact-modal-target' ) );
				return;
			}

			const closeTrigger = event.target.closest( '[data-contact-modal-close]' );
			if ( closeTrigger ) {
				event.preventDefault();
				closeModal( closeTrigger.closest( '[data-contact-modal]' ) );
				return;
			}

			const modal = event.target.closest( '[data-contact-modal]' );
			if ( modal && ! event.target.closest( '[data-contact-modal-panel]' ) ) {
				closeModal( modal );
			}
		} );

		document.addEventListener( 'keydown', ( event ) => {
			if ( 'Escape' === event.key && activeModal ) {
				closeModal( activeModal );
			}
		} );
	}

	strlInitDownloadHubspotForms();
}

strlInitDownloadModals();
